import React from 'react';
import './Testimony.css';
import { images } from '../../../assets';

function CarouselItem({ data }) {
  return (
    <div className='profilecontent'>
      <div className='profilephoto'>
        <img src={data.img} alt={data.name} />
      </div>
      <div className='profiletext'>
        <div className='stars'>
          <img src={images.starFull} alt='Star' />
          <img src={images.starFull} alt='Star' />
          <img src={images.starFull} alt='Star' />
          <img src={images.starFull} alt='Star' />
          <img src={images.starFull} alt='Star' />
        </div>
        <div className='description'>
            {data.description}
        </div>
        <div className='name'>
          {data.name}
        </div>
      </div>
    </div>
  );
}

export default CarouselItem;
